export enum RepairTypeEnum {
  'FieldRepair' = 'FieldRepair',
  'HOService' = 'HOService',
  'Internal' = 'Internal',
  'Overtime' = 'Overtime',
  'SpecialJobs' = 'SpecialJobs',
  'Piecework' = 'Piecework',
}
